// !TODO: Change antd to faicons
import { EnvironmentFilled, InfoCircleFilled, LinkOutlined, MailFilled, PhoneFilled } from '@ant-design/icons';
import { Button, Card, Col, Form, Input, Popconfirm, Row, Select, Switch } from 'antd';
import {  useState } from 'react';
import { getAll as getAllCountries } from "../../services/countriesService";
import { Vendor } from './vendorsModel';
import { Action } from './vendorsReducer';
import LinkQuickBooksVendorModal from './LinkQuickBooksVendorModal';

type Props = {
  vendor: Vendor
  dispatch: React.Dispatch<Action>
}

const countryOptions = getAllCountries().map((country) => ({
  label: country.name,
  value: country.code
}))

const VendorsForm = ({ vendor, dispatch }: Props) => {
  const [isQuickBooksModalVisible, setIsQuickBooksModalVisible] = useState(false);

  return <>
    <Form layout='vertical'>
      <Input type='hidden' value={vendor.id} />
      <Card
        title={<span><InfoCircleFilled /> Vendor Info</span>}
        bordered={false}
        style={{ marginBottom: 24 }}
      >
        <Form.Item>
          <Switch
            checked={vendor.isActive}
            onChange={() => dispatch({ type: 'VENDOR_IS_ACTIVE_CHANGED', value: !vendor.isActive })}
          />
          <span style={{ marginLeft: 8 }}>Active Vendor</span>
        </Form.Item>
        <Form.Item label='Vendor' style={{ width: '50%' }}>
          <Input
            placeholder='Vendor name'
            value={vendor.name}
            onChange={(event) => dispatch({ type: 'VENDOR_NAME_CHANGED', value: event.target.value })}
          />
        </Form.Item>
      </Card>

      <Card
        title={<span><EnvironmentFilled style={{ marginRight: 8 }} /> Vendor Address</span>}
        bordered={false}
        style={{ marginBottom: 24 }}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item>
              <Input
                placeholder='Street and number'
                value={vendor.address1}
                onChange={(event) => dispatch({ type: 'VENDOR_ADDRESS1_CHANGED', value: event.target.value })}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item>
              <Input
                placeholder='Apartment, suite, unit, building, floor, etc.'
                value={vendor.address2}
                onChange={(event) => dispatch({ type: 'VENDOR_ADDRESS2_CHANGED', value: event.target.value })}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label='City'>
              <Input
                value={vendor.city}
                onChange={(event) => dispatch({ type: 'VENDOR_CITY_CHANGED', value: event.target.value })}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item label='Postal Code / ZIP'>
              <Input
                value={vendor.postalCode}
                onChange={(event) => dispatch({ type: 'VENDOR_POSTAL_CODE_CHANGED', value: event.target.value })}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label='Country'>
              <Select
                showSearch
                placeholder="Select a country"
                optionFilterProp="label"
                onChange={value => dispatch({ type: 'VENDOR_COUNTRY_CHANGED', value })}
                onSearch={(value) => countryOptions.filter(option => option.label.toLowerCase().includes(value.toLowerCase()))}
                options={countryOptions}
                value={vendor.country}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label='State / Province / Region'>
              <Input
                value={vendor.countrySubDivisionCode}
                onChange={(event) => dispatch({ type: 'VENDOR_COUNTRY_SUB_DIVISION_CODE_CHANGED', value: event.target.value })}
              />
            </Form.Item>
          </Col>
        </ Row>
      </Card>

      <Card
        title={<span><PhoneFilled style={{ marginRight: 8 }} />Contact Information</span>}
        bordered={false}
        style={{ marginBottom: 24 }}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label='Primary Phone'>
              <Input
                addonBefore={<PhoneFilled />}
                value={vendor.primaryPhone}
                onChange={(event) => dispatch({ type: 'VENDOR_PRIMARY_PHONE_CHANGED', value: event.target.value })}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label='Mobile Phone'>
              <Input
                addonBefore={<PhoneFilled />}
                value={vendor.mobilePhone}
                onChange={(event) => dispatch({ type: 'VENDOR_MOBILE_PHONE_CHANGED', value: event.target.value })}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label='Email'>
              <Input
                addonBefore={<MailFilled />}
                value={vendor.email}
                onChange={(event) => dispatch({ type: 'VENDOR_EMAIL_CHANGED', value: event.target.value })}
              />
            </Form.Item>
          </Col>
        </Row>
      </Card>

      <Card
        title={<span><LinkOutlined style={{ marginRight: 8 }} />QuickBooks Online</span>}
        bordered={false}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label='Display Name'>
              <Input value={vendor.qboDisplayName} readOnly />
            </Form.Item>
          </Col>
          <Col span={12} style={{ marginTop: 28 }}>
            {
              vendor.qboId ? (
                <Popconfirm
                  title='Are you sure you want to remove this QuickBooks Online link?'
                  onConfirm={() => dispatch({ type: 'VENDOR_QBO_LINK_RESET' })}
                >
                  <Button type='primary' icon={<LinkOutlined />} danger>Remove QuickBooks Online Link</Button>
                </Popconfirm>
              ) : (
                <Button
                  type='primary'
                  icon={<LinkOutlined />}
                  style={{ backgroundColor: '#459b49' }}
                  onClick={() => setIsQuickBooksModalVisible(true)}
                >Link to QuickBooks Online</Button>
              )
            }
          </Col>
        </Row>
      </Card>
    </Form>

    <LinkQuickBooksVendorModal
      initialFilter={vendor.name}
      isOpen={isQuickBooksModalVisible}
      onCancel={() => setIsQuickBooksModalVisible(false)}
      onLink={(qboVendor, updateInfo) => {
        dispatch({ type: 'VENDOR_UPDATED_FROM_QBO', qboVendor, updateInfo })
        setIsQuickBooksModalVisible(false)
      }}
    />
  </>
};

export default VendorsForm;
